module.exports = __webpack_public_path__ + "static/media/bannerTwo.a30bd3e6.png";